<template>
  <div class="loading-mask">
    <div class="figure">
      <iconfont
        class="cutter-loading-icon"
        style="font-size:40px;"
        name="#icon11-41jianjizhong"
      ></iconfont>
    </div>
    <div class="text">
      视频添加中...
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.loading-mask {
  position: absolute;
  top: 62px;
  left: 0;
  width: 100%;
  height: 70%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;

  & .figure {
    color: #3058fe;
    animation: turn 2s linear infinite;
  }
  & .text {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-top: 15px;
  }
}
@keyframes turn {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
